import { useState } from "react";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import { IColumn, Icon, Stack, TooltipHost } from "@fluentui/react";
import { useAsignacionEquipos } from "../../../hooks/CheckList/Configuraciones/useAsignacionEquipos";
import HelperEstilos from "../../../utils/Estilos/HelperEstilos";
import { PanelAsignacionEquipo } from "./PanelAsignacionEquipo";
import { useBoolean } from "@fluentui/react-hooks";
import { ITableModeloEquipo } from "../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";

interface IDataPanelAsig {
  modeloEquipo: string;
  modeloEquipoId: string;
}

export const ConfigAsignacionEquipos = () => {
  const [dataPanelAsinganacionEquipos, setDataPanelAsignacionEquipos] =
    useState<IDataPanelAsig>({ modeloEquipo: "", modeloEquipoId: "" });
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const {
    loading,
    item,
    paginacion,
    searchBoxRefTable,
    _onkeyUpSearchModeloEquipo,
    onChangeSkip,
  } = useAsignacionEquipos();

  const column: IColumn[] = [
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "equipo",
      minWidth: 300,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "tipoEquipo",
      name: "Tipo de Equipo",
      fieldName: "tipoEquipo",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha",
      fieldName: "fecha",
      minWidth: 70,
      maxWidth: 70,
      isResizable: true,
    },
    {
      key: "opcionesa",
      name: "Opciones",
      fieldName: "opt",
      minWidth: 70,
      maxWidth: 70,
      isResizable: true,
      onRender: (item: ITableModeloEquipo) => (
        <TooltipHost content={`Asignar Personas`}>
          <Icon
            iconName="ContactList"
            style={{ cursor: "pointer" }}
            className={HelperEstilos.classNameIconTable.iconFont}
            onClick={() => {
              setDataPanelAsignacionEquipos({
                modeloEquipo: item.equipo,
                modeloEquipoId: item.equipoModeloId,
              });
              openPanel();
            }}
          />
        </TooltipHost>
      ),
    },
  ];

  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Equipo"
            componentRef={searchBoxRefTable}
            Titulo="Asignación de Equipos Autorizados"
            SubTitulo="Gestión de Equipos"
            onKeyUp={_onkeyUpSearchModeloEquipo}
          />
        </div>
        <br />
        <Stack>
          <TableBase2
            leftBar={[]}
            data={item}
            column={column}
            isLoading={loading}
            footerPagination={
              <PaginationFooterC
                paginacion={paginacion}
                onChangePagina={(e) => {
                  onChangeSkip(e);
                }}
              />
            }
          />
        </Stack>
      </div>
      <PanelAsignacionEquipo
        modeloEquipo={dataPanelAsinganacionEquipos.modeloEquipo}
        modeloEquipoId={dataPanelAsinganacionEquipos.modeloEquipoId}
        isOpen={isOpen}
        onDismiss={dismissPanel}
      />
    </>
  );
};
